(function($) {
  $(document).ready(function() {

      $('.midnight-4').attr('data-midnight', 'default');
      $('.midnight-3').attr('data-midnight', 'werbetechnik');
      $('.midnight-2').attr('data-midnight', 'cardesign');
      $('.midnight-1').attr('data-midnight', 'transparent');

      $('nav.fixed').midnight();
  });

}(jQuery));
